import { render, staticRenderFns } from "./knowledge-class-overview.vue?vue&type=template&id=7473310e&scoped=true"
import script from "./knowledge-class-overview.vue?vue&type=script&lang=js"
export * from "./knowledge-class-overview.vue?vue&type=script&lang=js"
import style0 from "./knowledge-class-overview.vue?vue&type=style&index=0&id=7473310e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473310e",
  null
  
)

export default component.exports